import { Axios } from '@src/app/context/Api/includes/Axios';
import { _translateCriteriaFilters } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isNil } from 'lodash';

/**
 * GetCommonCriteriaVersion
 *
 * @TODO Needs description.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetCommonCriteriaVersion = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/criteria/version/${thePayload?.versionId}`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    if (!isNil(remoteResponse?.data?.criteria)) {
      remoteResponse.data.criteria = _translateCriteriaFilters(remoteResponse?.data?.criteria, 'incoming');
    }

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Criteria/api/requests/queries/GetCommonCriteriaVersion.js -> GetCommonCriteriaVersion()',
      false,
      error
    );

    throw error;
  }
};
